import React, { useEffect, useState, useCallback , forwardRef} from "react";
import { useIntl } from "react-intl";
import { FileText , AlertTriangle, Check } from "react-feather";
import DatePicker from "react-datepicker";
import { zarcProcessing, getZarcDataset, saveZarcParams } from "../../../../api";
// import Select from '../../../../components/Select';
import Select from 'react-select';
import "./styles.scss";

const ZarcAnalysis = ({ LoteId, setError, ...props }) => {
  // console.log({LoteId});

	const { formatMessage } = useIntl();
  const [zarcResults, setZarcResults] = useState([]);
  const [filterOptionsCultura, setFilterOptionsCultura] = useState([]);
  const [filterOptionsSolo, setFilterOptionsSolo] = useState([]);
  const [filterOptionsGrupo, setFilterOptionsGrupo] = useState([]);
  
  const [selectedCultura, setSelectedCultura] = useState({});
  const [selectedSolo, setSelectedSolo] = useState({});
  const [selectedGrupo, setSelectedGrupo] = useState({});
  const [plantioInicio, setPlantioInicio] = useState(null);
  const [plantioFim, setPlantioFim] = useState(null);
  const [loading, setLoading] = useState(true);
  const [processed, setProcessed] = useState(false);
  const [isConforme, setIsConforme] = useState(null);

  const fetchZarcDataset = useCallback(() => {
    setLoading(true);
        
    getZarcDataset()
      .then(({ data }) => {
        const results = data.result ;
        // console.log(results);
        if(!!results.culturas) setFilterOptionsCultura(results.culturas);
        if(!!results.solos) setFilterOptionsSolo(results.solos);
        if(!!results.grupos) setFilterOptionsGrupo(results.grupos);
        setLoading(false);
      })
      .catch(err => {
        setError(
          err?.response?.data?.message || formatMessage({ id: "erro-api" })
        );
      });
  }, [formatMessage, setError]);

	const fetchResults = useCallback(() => {
    setLoading(true);

    zarcProcessing(LoteId)
      .then(({ data }) => {
        const results = data.result ;
        // console.log(data);

        setZarcResults(results.filtrado);
        setIsConforme(results.is_conforme);

        if(data.params.cultura) setSelectedCultura(data.params.cultura);
        if(data.params.solo) setSelectedSolo(data.params.solo);
        if(data.params.grupo) setSelectedGrupo(data.params.grupo);

        if(data.params.data_plantio_inicio) setPlantioInicio(new Date(data.params.data_plantio_inicio));
        if(data.params.data_plantio_fim) setPlantioFim(new Date(data.params.data_plantio_fim));
        
        setProcessed(true);
        setLoading(false);
        
      })
      .catch(err => {
        // setError(
        //   err?.response?.data?.message || formatMessage({ id: "erro-api" })
        // );
      });
	}, [LoteId]);

  useEffect(() => {
      fetchZarcDataset();
      fetchResults();
  }, [fetchResults, fetchZarcDataset]);

  const DatePickerCustom = forwardRef((props, ref) => (
    <input className="date-picker-custom" {...props} ref={ref} />
  ));

  const handleSaveZarcParams = () => {

    if( selectedCultura === null || selectedSolo === null || selectedGrupo === null || plantioInicio === null || plantioFim === null) {
      setError( formatMessage({ id: "erro-campos-obrigatorios" }) );
      return;
    }

    const postData = {
      "b3_lote_id" : LoteId,
      "agritec_cultura_id" : selectedCultura.value,
      "agritec_solo_id" : selectedSolo.value,
      "agritec_grupo_id" : selectedGrupo.value,
      "data_plantio_inicio" : plantioInicio,
      "data_plantio_fim" : plantioFim
    };
    // console.log(postData);
    
    setLoading(true);
    saveZarcParams(postData)
      .then(({ data }) => {
        // const results = data.result ;
        // console.log(results);

        zarcProcessing(LoteId)
          .then(({ data }) => {
            const results = data.result ;
            // console.log(results);
            setZarcResults(results.filtrado);
            setIsConforme(results.is_conforme);
            setLoading(false);
            setProcessed(true);
          })
          .catch(err => {
            setError(
              err?.response?.data?.message || formatMessage({ id: "erro-api" })
            );
            setLoading(false);
          });

      })
      .catch(err => {
        setError(
          err?.response?.data?.message || formatMessage({ id: "erro-api" })
        );
        setLoading(false);
      });

  };

  return (
    <>
      <h4>{formatMessage({ id: "zarc" })}</h4>

      <div className="columns">
        <div className="column">
          {formatMessage({ id: "cultura" })}
          <Select
            options={filterOptionsCultura}
            value={ selectedCultura }
            onChange={e => {
              // console.log(e);
              setSelectedCultura(e)
            }}

          />
        </div>

        <div className="column">
          {formatMessage({ id: "solo" })}
          <Select
            options={filterOptionsSolo}
            value={ selectedSolo }
            onChange={e => {
              // console.log(e);
              setSelectedSolo(e)
            }}
          />
        </div>

        <div className="column">
          {formatMessage({ id: "ciclo" })}
          <Select
            options={filterOptionsGrupo}
            value={ selectedGrupo }
            onChange={e => {
              // console.log(e);
              setSelectedGrupo(e)
            }}
          />
        </div>

        <div className="column">
          {formatMessage({ id: "plantio-inicio" })}<br/>
          <DatePicker 
            className="plantio-datepicker"
            selected={plantioInicio}
            dateFormat="dd/MM/yyyy"
            customInput={<DatePickerCustom />}
            onChange={date => { setPlantioInicio(date) }}
          /> 
        </div>

        <div className="column">

          {formatMessage({ id: "plantio-fim" })}<br/>
          <DatePicker
            className="plantio-datepicker"
            selected={plantioFim}
            dateFormat="dd/MM/yyyy"
            customInput={<DatePickerCustom />}
            onChange={date => { setPlantioFim(date) }}
          />
        </div>
        
      </div>
        
      <div className="columns">
        <div className="column is-one-fifth">
          <button
            className={`button ${loading ? " is-loading" : ""}`}
            onClick={handleSaveZarcParams}
          >
            {formatMessage({ id: "Salvar" })}
          </button>
        </div>

        <div className="column">
          {!loading && processed && isConforme === false && selectedCultura?.value  && (
            <span className = "nao-conforme">
              <AlertTriangle color="red" size={18} /> 
              {" "}{ formatMessage({ id: "zarc-nao-conforme" })}
            </span>
          ) }
          
          { !loading && processed && isConforme === true && selectedCultura?.value  &&(
            <span className = "conforme">
              <Check color="green" size={20} /> 
              {" "}{ formatMessage({ id: "zarc-conforme" })}
            </span>
          ) }
        </div>
      </div>


      {!loading && zarcResults.length === 0 ? (
        <div className="no-results">
          <FileText size="48px" />
          <p>{formatMessage({ id: "nenhuma-informacao-encontrada" })}</p>
        </div>
      ) : (
        <>
            <table className="table is-striped is-hoverable">
              <thead>
                <tr>
                  <th>{formatMessage({ id: "municipio" })}</th>
                  <th>{formatMessage({ id: "cultura" })}</th>
                  <th>{formatMessage({ id: "solo" })}</th>
                  <th>{formatMessage({ id: "ciclo" })}</th>
                  <th>{formatMessage({ id: "safra" })}</th>
                  <th>{formatMessage({ id: "periodo" })}</th>
                  <th>{formatMessage({ id: "risco" })}</th>
                </tr>
              </thead>
              <tbody>
                {!loading && zarcResults.length &&
                zarcResults.map( (result, k) => (
                  <tr key={k}>
                    <td> {result.municipio} </td>
                    <td> {result.cultura} </td>
                    <td> {result.solo} </td>
                    <td> {result.ciclo} </td>
                    <td> {result.safraIni}-{result.safraFim} </td>
                    <td> {result.diaIni}/{result.mesIni} a {result.diaFim}/{result.mesFim} </td>
                    <td> {result.risco} </td>
                  </tr>
                ))}
              </tbody>
            </table>
        </>
      )}
    </>
  );
};

export default ZarcAnalysis;

